import { createContext, type ReactNode, useContext } from "react";

type SiteNameContext = {
  siteName: string;
};

const SiteNameContext = createContext<SiteNameContext | null>(null);

SiteNameContext.displayName = "SiteNameContext";

const SiteNameProvider = ({ value, children }: { value: SiteNameContext; children: ReactNode }) => {
  return <SiteNameContext.Provider value={value}>{children}</SiteNameContext.Provider>;
};
SiteNameProvider.displayName = SiteNameProvider.name;

const useSiteName = (): SiteNameContext => {
  const context = useContext(SiteNameContext);
  if (!context) {
    throw new Error("No context found for SiteName");
  }
  return context;
};

export { SiteNameContext, SiteNameProvider, useSiteName };
